import { useEffect } from 'react';

import { JIRA_SYNC_POLL_MS } from '@/presentation/pages/developments/utils/jira-sync-pending.js';

export function useJiraSyncPolling(pending: boolean, refresh: () => void): void {
    useEffect(() => {
        if (!pending) {
            return;
        }
        const interval = setInterval(() => {
            refresh();
        }, JIRA_SYNC_POLL_MS);
        return () => clearInterval(interval);
    }, [pending, refresh]);
}
